export class ConjuntoVehiculoRecurso {
  id: number;
  codigo: string;
  nombre: string;
  descripcion: string;
  tipo_id: number;
  tipo: string;
}
